
import Routes from '@/router/Routes.ts';
// import { passToRouteSearchParams } from '@/utils/passToRouteSearchParams.ts';
// import SearchParams from '@/_constants/SearchParams.ts';
import AssessmentIcon from '@/components/icons/AssessmentIcon';
import ReportIcon from '@/components/icons/ReportIcon';
import TemplateIcon from '@/components/icons/TemplateIcon';
import ResourceIcon from '@/components/icons/ResourceIcon';
import DashboardIcon from '@/components/icons/DashboardIcon';
import RequestsIcon from '@/components/icons/RequestsIcon';
import OrganizationIcon from '@/components/icons/OrganizationIcon';
import { ReactNode } from 'react';

export interface NavItem {
  title: string;
  path: string;
  icon: ReactNode;
  activePaths?: string[];
}


export const nonprofitNavData: NavItem[] = [
  {
    title: 'navbar.assessments',
    path: Routes.ASSESSMENT,
    icon: <AssessmentIcon />,
  },
  {
    title: 'Organizations',
    path: Routes.ORGANIZATIONS,
    icon: <OrganizationIcon />,
    activePaths: ['/child-reports'], // Also active when viewing child reports
  },
  {
    title: 'navbar.results',
    path: Routes.REPORTS,
    icon: <ReportIcon />,
  },
  {
    title: 'navbar.plans',
    path: Routes.TEMPLATES,
    icon: <TemplateIcon />,
  },
  {
    title: 'navbar.resources',
    path: Routes.RESOURCES,
    icon: <ResourceIcon />,
  },
];

export const superadminNavData: NavItem[] = [
  {
    title: 'Dashboard',
    path: Routes.SUPER_ADMIN_ORGANIZATIONS,
    icon: <DashboardIcon />
  },
  {
    title: 'Requests',
    path: Routes.REQUESTS,
    icon: <RequestsIcon />
  },
];


export const childUserNavData: NavItem[] = [
  {
    title: 'navbar.assessments',
    path: Routes.ASSESSMENT,
    icon: <AssessmentIcon />,
  },
  {
    title: 'navbar.results',
    path: Routes.REPORTS,
    icon: <ReportIcon />,
  },
];

export const navData = nonprofitNavData;
